import { client } from './client';
import interceptors from './interceptors';
import qs from 'qs';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function updateAlamat(params) {
	return client.post('tunnel/api/stockist/profile/updatealamat', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
	});
}

function udateProfile(params) {
	return client.post('tunnel/api/stockist/profile/updateprofile', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
	});
}

function tutupToko(params) {
	return client.post('tunnel/api/stockist/profile/closestore', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
	});
}

function bukaToko() {
	return client.post('tunnel/api/stockist/profile/openstore');
}

function getDataProfile() {
	return client.get('tunnel/api/stockist/profile/data');
}

function getProfileDataCourier() {
	return client.get('tunnel/api/stockist/profile/datacourier');
}

function actProfileCourier(params) {
	return client.post('tunnel/api/stockist/profile/updatecourier', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function uploadImage(params) {
	return client.post('tunnel/upload_image_stockist', params, {
		header: {
			'Content-Type': 'multipart/form-data'
		},
	});
}

function getDataBank() {
	return client.get('tunnel/api/stockist/profile/databank');
}

function getScedule() {
	return client.get('tunnel/api/stockist/store/schedule');
}

function updateSchedule(params) {
	return client.post('tunnel/api/stockist/store/updateSchedule', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function getOptionBank() {
	return client.get('tunnel/api/public/general/bank');
}

function submitBank(params) {
	return client.post('tunnel/api/stockist/profile/updateBank', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

export default {
	updateAlamat,
	getDataProfile,
	udateProfile,
	getProfileDataCourier,
	actProfileCourier,
	tutupToko,
	uploadImage,
	getDataBank,
	getScedule,
	updateSchedule,
	bukaToko,
	getOptionBank,
	submitBank
}